import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Aplicar el filtro',
    desc: 'Aprende a identificar las señales antes de involucrarte emocionalmente.'
  }, {
    num: '02',
    title: 'Cambiar conducta',
    desc: 'Deja de reaccionar desde la carencia y empieza a actuar desde la elección.'
  }, {
    num: '03',
    title: 'Elevar estándares',
    desc: 'Define lo que mereces y no aceptes menos de lo que buscas.'
  }];
  return <Section className="bg-[#FAF8F5]" data-id="element-62">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#2D2D2D] mb-16" data-id="element-63">
        CÓMO FUNCIONA (3 PASOS)
      </h2>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-64">
        {steps.map((step, idx) => <div key={idx} className="relative" data-id="element-65">
            <div className="text-8xl font-serif font-bold text-[#D4735E]/10 absolute -top-10 -left-4 z-0" data-id="element-66">
              {step.num}
            </div>
            <div className="relative z-10 bg-white p-8 rounded-xl shadow-sm border border-[#D4735E]/10 h-full" data-id="element-67">
              <h3 className="text-xl font-bold text-[#2D2D2D] mb-3" data-id="element-68">
                {step.title}
              </h3>
              {/* Added descriptions inferred from context to balance the layout visually */}
            </div>
          </div>)}
      </div>
    </Section>;
}